import DashBoardTalentsMain from "./DashBoardTalentsMain";

export default DashBoardTalentsMain;